var map = {
	"./de-DE.json": 8239,
	"./en-US.json": 7852,
	"./es-ES.json": 9185,
	"./fr-FR.json": 2193,
	"./it-IT.json": 6151,
	"./ko-KO.json": 9389,
	"./pt-BR.json": 7025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8537;